export const TAB_CHILD_ROUTE_PRIORITY: Record<string, string[]> = {
  VERIFICATIONS: ["PRIMARY_VERIFICATIONS", "OTHER_VERIFICATIONS", "NEUROFIN"]
};

export const TAB_CHILD_ROUTE_MAP: Record<string, Record<string, string>> = {
  VERIFICATIONS: {
    PRIMARY_VERIFICATIONS: "/verification/my-verifications",
    OTHER_VERIFICATIONS: "/verification/other-verifications",
    NEUROFIN: "/verification/neurofin-verification"
  }
};

export interface TabChildPermission {
  isVisible?: boolean;
  href?: string;
  [key: string]: unknown;
}

export interface TabPermissionConfig {
  children?: Record<string, TabChildPermission>;
  [key: string]: unknown;
}

export interface GetVisibleTabRouteArgs {
  tabId: string;
  tabPermission?: TabPermissionConfig;
  fallbackRoute: string;
}
